import React from 'react';
// data
import Data from '../../../../model/Data';
import { countries } from '../../data.json';
import { links } from '../../data.json';
// styles
import './Description.css'

interface Props {
  className?: string;
}
interface Country {
  name: string,
  engName: string
}

class Description extends React.Component<Props> {
  render(): JSX.Element {
    
    const coma = <span>, </span>;
    const addGeography = (countries: Array<Country>) => {
      const countryString = (c: Country, index: number): JSX.Element => {
        return (
          <span key={`key-${index}`} className="no-break1">
            <span className={`flag flag--${c.engName}`}></span>
            {c.name}
            { index !== countries.length - 1 ? coma : '' }
          </span>
        )
      };
      return countries.map((m, i) => countryString(m, i));
    };

    return (
      <div className="about-description">
        <div className="container">
          <div className="about-description__general">
            Группа компаний <a href={links.uchi_ru}>Учи.ру</a> <wbr/>
            10&nbsp;лет создает EdTech&#8209;продукты и&nbsp;сервисы <wbr/>
            для&nbsp;учеников школьного&nbsp;возраста <wbr/>
            и&nbsp;учителей. 
          </div>
          <div className="about-description__departments">
            <div className="about-description__departments-header">В группе компаний:</div>
            <ul className="about-description__departments-list departments">
              <li className="departments__item">Учи.ру — образовательная онлайн&#8209;платформа для&nbsp;самостоятельного обучения</li>
              <li className="departments__item">Учи.Дома — онлайн&#8209;школа для&nbsp;занятий с&nbsp;репетитором</li>
              <li className="departments__item">Учи.Ответы — образовательный сайт</li>
              <li className="departments__item">Учи.Кружки — сеть офлайн&#8209;кружков по&nbsp;математике, программированию и&nbsp;английскому языку</li>
              <li className="departments__item">ЯКласс — образовательный онлайн&#8209;ресурс</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default Description;
